<template>
  <div class="menu">
    <div class="header">
      <div class="logo" @click="changeView('portal')">
        <img src="@/assets/portal/logo-20191111.png" />
        {{ i18nTitle("管理控制台") }}
      </div>
      <!-- 切换租户项目 -->
      <div
        class="change-tenant-prject"
        @mouseleave="istenantProjectShow = false"
      >
        <a
          @click.stop="getTenantProject"
          href="javascript:void(0)"
          style="color: #FFF;margin-left:24px"
        >
          {{
            (v_tenant_selected.name ? v_tenant_selected.name : "") +
              " / " +
              (v_project_selected.name ? v_project_selected.name : "")
          }}
          <img
            src="@/assets/arrow.png"
            :class="istenantProjectShow ? 'activedirection' : ''"
            style="width: 12px; margin-left: 5px;"
          />
        </a>
        <div class="tenantProject" v-show="istenantProjectShow">
          <div class="search">
            <div>
              <input
                type="text"
                :placeholder="i18nTitle('请输入搜索内容')"
                v-model="searchContent"
                @click="touchTrack('C_TenantProject', 'tenantsearch')"
                @keyup="search"
              />
              <img
                src="@/assets/search.svg"
                style="width: 13px;position: absolute;top: 25px;right: 42px;"
              />
            </div>
          </div>
          <div
            class="content"
            v-if="!searchContent && tenantProjectData.length > 0"
          >
            <div class="part">
              <div class="title" style="padding-left:24px">
                {{ i18nTitle("租户列表") }}
              </div>
              <div class="group">
                <template v-for="(item, index) in tenantProjectData">
                  <div
                    :class="
                      tenantActiveIndex === index
                        ? 'item itemActive'
                        : item.projects.length > 0
                        ? 'item'
                        : 'item forbid'
                    "
                    :key="index"
                    @click="
                      choseTenant(index);
                      touchTrack('C_' + item.tenant_name, 'tenantlist');
                    "
                    style="padding-left:24px;padding-right:48px"
                    :title="item.tenant_name + '-' + item.desc"
                  >
                    <span>{{ item.tenant_name + "-" + item.desc }}</span>
                    <img
                      src="@/assets/arrow.svg"
                      v-if="tenantActiveIndex === index"
                      style="width: 13px;position: absolute;top: 12px;right: 8px;"
                    />
                  </div>
                </template>
              </div>
            </div>
            <div class="dividingline"></div>
            <div class="part" v-if="tenantActiveIndex > -1">
              <div class="title">{{ i18nTitle("项目列表") }}</div>
              <div class="group">
                <template
                  v-for="(item, index) in tenantProjectData[tenantActiveIndex]
                    .projects"
                >
                  <div
                    :class="
                      projectActiveIndex === index ? 'item itemActive' : 'item'
                    "
                    :key="index"
                    @click.stop="choseProject(index)"
                    :title="item.project_name + '-' + item.name_zh"
                  >
                    <span>{{ item.project_name + "-" + item.name_zh }}</span>
                  </div>
                </template>
              </div>
            </div>
            <div class="dividingline"></div>
            <div class="part" v-if="tenantActiveIndex > -1">
              <div class="title">{{ i18nTitle("最近项目") }}</div>
              <div class="group">
                <template
                  v-for="(item, index) in tenantProjectData[tenantActiveIndex]
                    .projects"
                >
                  <div
                    class="item"
                    v-show="index < 4"
                    :key="index"
                    style="padding-right:18px;width:358px"
                    :title="item.project_name"
                  >
                    <span>{{ item.project_name }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div
            class="content"
            v-if="!searchContent && !tenantProjectData.length"
          >
            <div style="text-align: center;width:100%">
              {{ i18nTitle("没有可选租户项目") }}
            </div>
          </div>
          <div class="searchResult" v-if="searchContent">
            <template
              v-for="(item, index) in tenantProjectData"
              v-if="!searchNoData"
            >
              <template v-for="(obj, i) in item.projects" v-if="item.show">
                <div
                  class="searchResultItem"
                  :key="index + '-' + i"
                  @click.stop="searchClick(index, i)"
                  style="padding-left:24px"
                  v-if="obj.show"
                >
                  <span
                    v-html="
                      dealStr(
                        item.tenant_name,
                        obj.project_name,
                        item.desc,
                        obj.name_zh
                      )
                    "
                    >{{
                      dealStr(
                        item.tenant_name,
                        obj.project_name,
                        item.desc,
                        obj.name_zh
                      )
                    }}</span
                  >
                </div>
              </template>
            </template>
            <div v-if="searchNoData" style="text-align: center;">
              {{ i18nTitle("无匹配数据") }}
            </div>
          </div>
        </div>
      </div>
      <!-- 切换租户项目 -->
      <div class="tenant-project">
        <label
          class="handleLog"
          @click="btnGotopage(7, specialMenu[7].menu[0], 0)"
          v-if="specialMenu[7].show"
          >{{ i18nTitle("备案") }}</label
        >
        <div class="littledivideline"></div>
        <div
          class="language"
          @mouseover="isLangMenuShow = true"
          @mouseout="isLangMenuShow = false"
        >
          {{ title }}
          <img
            src="@/assets/arrow.png"
            :class="isLangMenuShow ? 'activedirection' : ''"
            style="font-size: 14px; margin-left: 8px;}"
          />
          <div class="langMenu" v-show="isLangMenuShow">
            <template v-for="item in localList">
              <div
                @click="selectLang(item.id)"
                :key="item.id"
                :class="[
                  'langMenuItem',
                  { langActiveItem: $i18n.locale === item.id }
                ]"
              >
                {{ i18nTitle(item.name) }}
              </div>
            </template>
          </div>
        </div>
        <div class="littledivideline"></div>
        <label
          class="handleLog"
          @click="btnGotopage(4, specialMenu[4].menu[0], 0)"
          v-if="specialMenu[4].show"
          >{{ i18nTitle("工单") }}</label
        >
        <div class="littledivideline" v-if="specialMenu[4].show"></div>
        <div
          class="feeCenter"
          @mouseover="isFeeMenuShow = true"
          @mouseout="isFeeMenuShow = false"
          v-if="specialMenu[0].show"
        >
          {{ i18nTitle("费用") }}
          <img
            src="@/assets/arrow.png"
            :class="isFeeMenuShow ? 'activedirection' : ''"
            style="font-size: 14px; margin-left: 8px;}"
          />
          <div class="feeMenu" v-show="isFeeMenuShow">
            <template v-for="(item, i) in specialMenu[0].menu">
              <div
                @click="btnGotopage(0, item, i)"
                :key="i"
                v-if="item.show"
                class="feeMenuItem"
              >
                {{ i18nTitle(item.menuName) }}
              </div>
            </template>
          </div>
        </div>
        <div class="littledivideline" v-if="specialMenu[0].show"></div>
        <label
          class="handleLog"
          @click="btnGotopage(1, specialMenu[1].menu[0], 0)"
          v-if="specialMenu[1].show"
          >{{ i18nTitle("操作日志") }}</label
        >
        <div class="littledivideline" v-if="specialMenu[1].show"></div>
        <div
          class="message-center"
          style="display:inline-block;padding-right:20px;padding-left:10px;position:relative;"
          @mouseenter="showMesCen(true, true)"
          @mouseleave="showMesCen(false)"
        >
          <i
            class="fa fa-bell-o"
            @click="btnGotopage(6, specialMenu[6].menu[0], 0)"
          >
            <p class="message-badge" v-if="unread_num > 0 && unread_num < 99">
              {{ unread_num }}
            </p>
            <p class="message-badge" v-if="unread_num >= 99">99+</p>
          </i>
          <div class="message-list-box" v-show="messageCenter.messageFlag">
            <ul v-if="messageCenter.messageList.length">
              <template v-for="(item, index) in messageCenter.messageList">
                <li
                  :key="item.id"
                  v-if="index < 5"
                  @click="gotoDetailPage(item)"
                >
                  <p
                    class="unread"
                    :class="{ 'unread-hide': item.is_read }"
                  ></p>
                  <span class="preview" v-if="item.is_preview">{{
                    i18nTitle("预览")
                  }}</span
                  ><span style="padding-left:6px;">{{ item.subject }}</span>
                </li>
              </template>
              <li
                class="viewMore"
                v-if="messageCenter.messageList.length > 6"
                @click="btnGotopage(6, specialMenu[6].menu[0], 0)"
              >
                {{ i18nTitle("查看更多") }} >
              </li>
            </ul>
          </div>
        </div>
        <div
          :class="isShowUserMsg ? 'ava avabc' : 'ava'"
          @mouseover="showUserMsg(true)"
          @mouseout="showUserMsg(false)"
        >
          <img src="@/assets/av.png" style="margin-right:8px" />
          {{ userName }}
          <img
            src="@/assets/arrow.png"
            :class="isShowUserMsg ? 'activedirection' : ''"
            style="margin-left: 8px;}"
          />
        </div>
      </div>
      <!-- <div class="message-list-box" v-show="messageCenter.messageFlag" @mouseover="showMesCen(true)" @mouseout="showMesCen(false)">
        <ul>
          <template v-for="(item, index) in messageCenter.messageList">
            <li :key="item.id" v-if="index < 5" @click="gotoDetailPage(item)">
              <p class="unread" :class="{'unread-hide': item.is_read }"></p><span class="preview" v-if="item.is_preview">{{i18nTitle('预览')}}</span><span style="padding-left:6px;">{{item.subject}}</span>
            </li>
          </template>
          <li class="viewMore" v-if="messageCenter.messageList.length > 6" @click="btnGotopage(6,specialMenu[6].menu[0],0)">{{i18nTitle('查看更多')}} ></li>
        </ul>
      </div> -->
      <div
        class="user-msg"
        v-show="isShowUserMsg"
        @mouseover="showUserMsg(true)"
        @mouseout="showUserMsg(false)"
      >
        <div class="user-info">
          <a @click="btnGotopage(3, specialMenu[3].menu[0], 0)">{{
            userName
          }}</a>
        </div>
        <div class="user-info">
          <a @click="btnGotopage(3, specialMenu[3].menu[0], 0)">{{
            i18nTitle("用户信息")
          }}</a>
        </div>
        <div class="user-info" v-if="specialMenu[2].menu[0].show">
          <a @click="btnGotopage(2, specialMenu[2].menu[0], 0)">{{
            i18nTitle("访问权限")
          }}</a>
        </div>
        <div class="user-info">
          <a @click="btnGotopage(5, specialMenu[5].menu[0], 0)">{{
            i18nTitle("反馈建议")
          }}</a>
        </div>
        <div class="sign-out">
          <div class="btn-sign-out fright" @click="loginout">
            <a href="javascript:void(0);">{{ i18nTitle("退出") }} </a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="menucontainer" > -->
    <div
      :class="
        isCollapse ? 'menucontainer navbar-collapse-close' : 'menucontainer'
      "
      style="height: calc(100vh - 64px);"
    >
      <!-- 左侧一级 -->
      <div class="menusub" value="true">
        <template v-for="(item, i) in menu">
          <div
            @click="changeFirst(item, i)"
            :key="i"
            :class="activeFirst === i ? 'subbtn active' : 'subbtn'"
            v-if="item.show"
          >
            <Tooltip
              :content="i18nTitle(item.title)"
              placement="right"
              :transfer="tooltip_transfer"
            >
              <img :src="item.icon" style="width:14px;" />
            </Tooltip>
          </div>
        </template>
      </div>
      <!-- 左侧二级 -->
      <div class="submenu" v-if="activeFirst > -1">
        <template>
          <div class="subTitle">{{ i18nTitle(menu[activeFirst].title) }}</div>
          <template v-for="(item, index) in menu[activeFirst].menu">
            <div
              v-if="item.show"
              @click="gotoPage(item, index)"
              :key="index"
              class="subbtn"
              :class="activeSecond === index ? 'subactive' : ''"
            >
              <a>{{ i18nTitle(item.menuName) }}</a>
            </div>
          </template>
        </template>
        <template v-if="activeFirst === -1 && activeFirstSpecial > -1">
          <div class="subTitle">
            {{ i18nTitle(specialMenu[activeFirstSpecial].title) }}
          </div>
          <template
            v-for="(item, index) in specialMenu[activeFirstSpecial].menu"
          >
            <div
              v-if="item.show"
              @click="gotoPage(item, index)"
              :key="index"
              class="subbtn"
              :class="activeSecond === index ? 'subactive' : ''"
            >
              <a>{{ i18nTitle(item.menuName) }}</a>
            </div>
          </template>
        </template>
      </div>
      <Designer
        v-if="showRPA"
        :hrefUrl="hrefUrl"
        style="flex:1;border: 0;"
        :class="activeFirst == -1 ? 'left' : ''"
      />
      <div class="navbar-collapse" v-if="activeFirst > -1">
        <div class="navbar-collapse-content" @click="collapseSubmenu">
          <div class="navbar-collapse-bg"></div>
          <div class="navbar-collapse-inner">
            <i class="fa fa-exchange" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div
        :class="isDetail ? 'content cover' : 'content'"
        v-if="contentShow && !showRPA"
      >
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
      <!-- </div> -->
      <Modal v-model="changeTenant" :title="i18nTitle('警告')" @on-ok="ok">
        <p>
          {{
            i18nTitle("如果确定修改，当前的页面将被重新加载, 仍要进行修改吗")
          }}？
        </p>
      </Modal>
      <Modal
        v-model="changeLang"
        :title="i18nTitle('警告')"
        @on-ok="changeLangOk"
      >
        <p>
          {{
            i18nTitle("如果确定修改，当前的页面将被重新加载, 仍要进行修改吗")
          }}？
        </p>
      </Modal>
    </div>
  </div>
</template>
<script>
import { cookies } from "@/common/cookieUtils";
import tenantProject from "@/common/tenant-project.js";
import menuList from "@/common/menuList.js";
import API from "@/config/APIs";
import uuidv1 from "uuid/v1";
import { mapMutations } from "vuex";
import Designer from "./designer.vue";
// import Vue from "vue";

export default {
  // // 无权限路由拦截
  // beforeRouteEnter(to, from, next) {
  //   Vue.prototype.$httpRequestEntrance.httpRequestEntrance(
  //     "GET",
  //     "/v1/users/policies",
  //     {},
  //     res => {
  //       let policiesData = res.data.filter(item => {
  //         return item.operation_code === "get";
  //       });
  //       policiesData = policiesData.concat([
  //         { resource_code: "backup" },
  //         { resource_code: "sync" }
  //       ]);
  //       let currentPage = null;
  //       let detailPage = null;
  //       let currentAccess = true;
  //       let accessMenu = []; // 获取所有菜单中有权限的目录
  //       if (to.meta.previousMenu) {
  //         currentPage = to.meta.previousMenu;
  //         detailPage = to.name;
  //       } else {
  //         currentPage = to.name;
  //       }
  //       menuList.manage.list.forEach(item => {
  //         item.menu.forEach(obj => {
  //           if (
  //             obj.code === "unlimited" ||
  //             policiesData.findIndex(a => obj.code === a.resource_code) > -1
  //           ) {
  //             accessMenu.push(obj);
  //             if (currentPage === obj.menuUrl) {
  //               currentAccess = true;
  //               if (detailPage) {
  //                 // 若可能为详情页
  //                 Object.keys(to.params).length
  //                   ? (currentAccess = false)
  //                   : (currentAccess = true);
  //               }
  //             }
  //           } else {
  //             if (currentPage === obj.menuUrl) {
  //               // 刷新后当前二级菜单无权限
  //               currentAccess = false;
  //             }
  //           }
  //         });
  //       });
  //       if (!currentAccess) {
  //         // 当前页无权限
  //         if (accessMenu.length > 0) {
  //           // 判断是否所有菜单都无权限
  //           next({ name: accessMenu[0].menuUrl }, vm => {
  //             vm.menuResData = res;
  //           });
  //         } else {
  //           // 菜单首选项无权限则跳转账号信息页
  //           next({ path: "/accountinfo" }, vm => {
  //             vm.menuResData = res;
  //           });
  //         }
  //       } else {
  //         next(vm => {
  //           vm.menuResData = res;
  //         });
  //       }
  //     },
  //     {},
  //     () => {
  //       next();
  //     }
  //   );
  // },

  data() {
    return {
      showRPA: false,
      // hrefUrl: "/accounts/cloud",
      // hrefUrl: "/designer",
      hrefUrl: "/accounts/cloud",
      menuResData: null,
      tooltip_transfer: true, // 兼容Tooltip
      menu: menuList.manage.list,
      activeFirst: -1,
      activeSecond: -1,
      activeFirstSpecial: -1,
      isDetail: false, //是否包含三级菜单
      // isOpen:false,//左侧一级菜单展开
      contentShow: false, //权限接口返回才开始加载路由内容
      isCollapse: false, //左侧二级是否展开
      isFeeMenuShow: false, //费用中心菜单展开
      isLangMenuShow: false, //语言菜单展开
      specialMenu: [
        {
          title: "费用中心",
          show: true,
          menu: [
            {
              menuName: "订单管理",
              menuUrl: "orderManage",
              code: "fitportal.orders",
              show: true
            },
            {
              menuName: "费用中心",
              menuUrl: "costCenter",
              code: "fitportal.credit.tenant.balance",
              show: true
            },
            {
              menuName: "项目额度管理",
              menuUrl: "projectLimitManage",
              code: "fitportal.credit.projects.quota",
              show: true
            },
            {
              menuName: "混合云租户账单总览",
              menuUrl: "billOverviewMixcloud",
              code: "fitportal.new.bills.statisticsbyvendor",
              show: true
            },
            {
              menuName: "招商云租户账单概览",
              menuUrl: "tenantBillOverview",
              code: "fitportal.bills.tenants.summary",
              show: true
            },
            {
              menuName: "公有云租户账单概览",
              menuUrl: "billOverviewPublicCloud",
              code: "public_cloud.bill.statistics",
              show: true
            },
            {
              menuName: "招商云租户账单明细",
              menuUrl: "tenantBillDetail",
              code: "fitportal.bills.tenants.monthlybills",
              show: true
            },
            {
              menuName: "公有云租户账单明细",
              menuUrl: "bilDetailPublicCloud",
              code: "public_cloud.bill",
              show: true
            },
            {
              menuName: "招商云项目账单概览",
              menuUrl: "projectBillOverview",
              code: "fitportal.bills.projects.summary",
              show: true
            },
            {
              menuName: "招商云项目账单明细",
              menuUrl: "projectBillDetail",
              code: "fitportal.bills.projects.monthlybills",
              show: true
            },
            {
              menuName: "成本优化分析",
              menuUrl: "zoneBillCostSeo",
              code: "cost.optimization.summary",
              show: true
            },
            {
              menuName: "账单核对",
              menuUrl: "billCheck",
              code: "fitportal.invoice.verifybills",
              show: true
            },
            {
              menuName: "发票信息管理",
              menuUrl: "receiptInfoManage",
              code: "fitportal.invoice.drawers",
              show: true
            },
            {
              menuName: "开票管理",
              menuUrl: "billApply",
              code: "fitportal.invoice.apply",
              show: true
            }
          ]
        },
        {
          title: "日志",
          show: true,
          menu: [
            {
              menuName: "操作日志查询",
              menuUrl: "logManage",
              code: "admin.auth.log",
              show: true
            }
          ]
        },
        {
          title: "认证授权",
          show: true,
          menu: [
            {
              menuName: "策略组管理",
              menuUrl: "policiesManage",
              code: "admin.auth.policies",
              show: true
            },
            {
              menuName: "授权管理",
              menuUrl: "policieTemplates",
              code: "iam.permissions_templates",
              show: true
            },
            {
              menuName: "运营管理",
              menuUrl: "standardTreeManage",
              code: "iam.permissions_templates",
              show: true
            }
            // {
            //   menuName: '项目管理',
            //   menuUrl: 'projectManage',
            //   code: 'auth.project',
            //   show:true
            // },
          ]
        },
        {
          title: "用户信息",
          show: true,
          menu: [
            {
              menuName: "账号信息",
              menuUrl: "accountinfo",
              code: "unlimited",
              show: true
            },
            {
              menuName: "企业认证",
              menuUrl: "auth",
              code: "unlimited",
              show: true
            }
          ]
        },
        {
          title: "工单管理",
          show: true,
          menu: [
            {
              menuName: "工单列表",
              menuUrl: "workorderList",
              code: "unlimited",
              show: true
            },
            {
              menuName: "提交工单",
              menuUrl: "workorderAdd",
              code: "unlimited",
              show: true
            }
          ]
        },
        {
          title: "建议",
          show: true,
          menu: [
            {
              menuName: "反馈建议",
              menuUrl: "opinionList",
              code: "unlimited",
              show: true
            }
          ]
        },
        {
          title: "站内信",
          show: true,
          menu: [
            {
              menuName: "站内信",
              menuUrl: "siteMessagesUnread",
              code: "unlimited",
              show: true
            },
            {
              menuName: "消息设置",
              menuUrl: "siteMessasgesSet",
              code: "unlimited",
              show: true
            }
          ]
        },
        {
          title: "备案",
          show: true,
          menu: [
            {
              menuName: "ISP备案",
              menuUrl: "isp",
              code: "unlimited",
              show: true
            }
          ]
        }
      ],
      userName: localStorage.getItem("username"),
      useremail: localStorage.getItem("useremail"),
      changeTenant: false,
      isShowUserMsg: false,
      v_tenant_selected: "",
      v_project_selected: "",
      modelTip: {
        // 模态框提示关键信息配置
        key: "name",
        value: null
      },
      istenantProjectShow: false,
      tenantProjectData: [],
      tenantActiveIndex: -1,
      projectActiveIndex: -1,
      searchContent: "",
      searchResult: [],
      searchNoData: false,

      messageCenter: {
        messageFlag: false,
        messageList: [],
        unread_num: 0,
        sum_num: "",
        reconnectLock: false,
        timeout: 60000, //1分钟发一次心跳
        timeoutObj: null,
        serverTimeoutObj: null,
        wsStop: false // 为true时执行关闭不再执行重连机制
      },
      websock: {},

      // i18n
      langList: {
        "zh-CN": "语言",
        "zh-TW": "語言",
        "en-US": "Lang"
      },
      localList: [
        { name: "中文简体", id: "zh-CN" },
        { name: "中文繁体", id: "zh-TW" }
      ],
      langVal: "",
      changeLang: false,
      throttleTrack: "",
      touch: {
        firewallManage: { id: "C_FWbtn", desc: "C_防火墙FW" }
      }
    };
  },
  watch: {
    $route: function() {
      let currentPage = this.$route.meta.previousMenu
        ? this.$route.meta.previousMenu
        : this.$route.name;
      if (this.$route.name) this.isDetail = this.$route.name.includes("_");
      if (!this.isDetail) {
        this.menu.map((item, index) => {
          item.menu.map((obj, i) => {
            if (obj.menuUrl === currentPage) {
              this.activeFirst = item.title == "RPA" ? -1 : index;
              this.activeSecond = i;
            }
          });
        });
      }
    }
  },
  components: {
    Designer
  },
  computed: {
    unread_num() {
      return this.$store.state.messageNum;
    },
    title() {
      return this.langList[this.$i18n.locale];
    }
  },
  created() {
    this.getUnread();
  },
  async mounted() {
    await tenantProject.initPage(this);
    this.showRPA = true;
    this.getMenuList();
    window.onbeforeunload = () => {
      this.websock.close();
    };
    if (this.$route.name) this.isDetail = this.$route.name.includes("_");

    //this.$nextTick(()=>{
    //  this.changeFirst( this.menu[ this.menu.length-1 ], 0 );
    //})

    // 在开启多窗口情况下，为保持数据显示正确性，在窗口激活时同步数据
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        if (
          this.v_tenant_selected.id !==
            JSON.parse(localStorage.getItem("tenant")).id ||
          this.v_project_selected.id !==
            JSON.parse(localStorage.getItem("project")).id
        ) {
          this.$Notice.info({
            title: this.i18nTitle("为保持数据一致性，页面将进行刷新操作！")
          });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      }
    });
    this.setLocal(this.$i18n.locale);
    //搜索消抖延时函数
    this.throttleTrack = this.throttle(this.touchTrack, 1500);
  },
  methods: {
    throttle(fn, delay) {
      let last = 0;
      let timer = 0;
      return function() {
        let context = this;
        let args = arguments;
        let now = new Date().getTime();
        if (now - last < delay) {
          clearTimeout(timer);
          timer = setTimeout(function() {
            last = now;
            fn.apply();
          }, delay);
        } else {
          last = now;
          fn.apply(context, args);
        }
      };
    },
    ...mapMutations(["setLocal"]),
    // i18n
    selectLang(name) {
      this.langVal = name;
      this.changeLang = true;
    },
    changeLangOk() {
      this.$i18n.locale = this.langVal;
      this.setLocal(this.langVal);
      window.location.reload();
    },
    /*获取相关接口对菜单进行权限处理 */
    menuDataDeal(resData) {
      let policiesData = resData.data.filter(item => {
        return item.operation_code === "get";
      });
      policiesData = policiesData.concat([
        { resource_code: "backup" },
        { resource_code: "sync" }
      ]);
      this.$store.commit("updateMenu", policiesData);
      let currentPage = null;
      currentPage = this.$route.meta.previousMenu
        ? this.$route.meta.previousMenu
        : this.$route.name;
      this.menu = menuList.manage.list.map((item, index) => {
        item.menu = item.menu.map((obj, i) => {
          obj.show = true;
          if (
            obj.code === "unlimited" ||
            policiesData.findIndex(a => obj.code === a.resource_code) > -1
          ) {
            if (currentPage === obj.menuUrl) {
              this.activeFirst = item.title == "RPA" ? -1 : index;
              this.activeSecond = i;
            }
          } else {
            obj.show = false;
            if (currentPage === obj.menuUrl) {
              // 刷新后当前二级菜单无权限
            }
          }
          return obj;
        });
        item.show =
          item.menu.filter(menu => {
            return menu.show === true;
          }).length > 0
            ? true
            : false; //如果子菜单都不显示，则父级菜单该模块不显示
        return item;
      });
      this.specialMenu = this.specialMenu.map((item, index) => {
        item.menu = item.menu.map((obj, i) => {
          obj.show = true;
          if (
            obj.code === "unlimited" ||
            policiesData.findIndex(a => obj.code === a.resource_code) > -1
          ) {
            if (currentPage === obj.menuUrl) {
              this.activeFirst = -1;
              this.activeFirstSpecial = index;
              this.activeSecond = i;
            }
          } else {
            obj.show = false;
          }
          return obj;
        });
        item.show =
          item.menu.filter(menu => {
            return menu.show === true;
          }).length > 0
            ? true
            : false; //如果子菜单都不显示，则父级菜单该模块不显示
        return item;
      });
      this.contentShow = true;
    },
    getMenuList() {
      if (this.menuResData) {
        this.menuDataDeal(this.menuResData);
      } else {
        this.$httpRequestEntrance.httpRequestEntrance(
          "GET",
          this.apiCenter.manage.authorizations.users_manage.menu_list +
            "/policies",
          {},
          resData => {
            this.menuDataDeal(resData);
          }
        );
      }
    },
    /*控制左侧一级菜单收缩展开 */
    // switchMenu(val){
    //   if(val === undefined){
    //     this.isOpen = !this.isOpen
    //   }else{
    //     this.isOpen = val
    //   }
    // },
    /*点击一级菜单 */
    changeFirst(item, index) {
      // this.isOpen = false
      if (item.platform) {
        let url = this.$publicMethod["getURL" + item.platform](
          item.menu[0].menuUrl
        );
        location.replace(url);
        // window.open(url,'_self')
      }
      this.activeFirst = item.title == "RPA" ? -1 : index;
      for (let i = 0; i < item.menu.length; i++) {
        if (item.menu[i].show) {
          this.activeSecond = i;
          this.$router.push({ name: item.menu[i].menuUrl });
          break;
        }
      }

      if (item.title == "RPA") {
        this.showRPA = true;
      } else {
        this.showRPA = false;
      }
    },
    /*点击二级菜单*/
    gotoPage(item, index) {
      if (this.touch[item.menuUrl]) {
        let obj = this.touch[item.menuUrl];
        if (this.$validate.isEmpty(obj)) {
          let id = obj.id;
          let params = {
            describe: obj.desc
          };
          this.$touch.track(id, params);
        }
      }
      this.activeSecond = index;
      // this.$router.push({ name: item.menuUrl });

      if (item.type == "rpa") {
        this.hrefUrl = item.menuUrl;
      } else {
        let url = this.$publicMethod["getCloudUrl"](item.menuUrl);
        location.replace(url);
      }
    },

    /**点击页面中零散分布的按钮 */
    btnGotopage(flag, item, index) {
      this.activeFirst = -1;
      this.activeFirstSpecial = flag;
      this.activeSecond = index;
      this.isFeeMenuShow = false;
      this.$router.push({ name: item.menuUrl });
    },
    /**二级菜单小按钮点击收缩展开 */
    collapseSubmenu() {
      this.isCollapse = !this.isCollapse;
    },
    /************************ */
    //获取租户项目
    getTenantProject() {
      if (this.istenantProjectShow) {
        this.istenantProjectShow = false;
        return;
      }
      this.searchContent = "";
      this.tenantProjectData = [];
      this.$httpRequestEntrance.httpRequestEntrance(
        "GET",
        "v1/auth/territories",
        { enabled: true, __limit: 1000 },
        responseData => {
          let res = responseData.data;
          this.istenantProjectShow = true;
          if (responseData.count > 0) {
            this.tenantProjectData = res.map(item => {
              item.desc = item.desc === null ? "N/A" : item.desc;
              item.show = false;
              item.projects = item.projects.map(obj => {
                obj.name_zh = obj.name_zh === null ? "N/A" : obj.name_zh;
                obj.show = false;
                return obj;
              });
              return item;
            });
            this.tenantActiveIndex = res.findIndex(item => {
              return item.tenant_id === this.v_tenant_selected.id;
            });
            this.projectActiveIndex = res[
              this.tenantActiveIndex
            ].projects.findIndex(item => {
              return item.project_id === this.v_project_selected.id;
            });
          }
        }
      );
    },
    //选择租户
    choseTenant(index) {
      if (this.tenantProjectData[index].projects.length > 0) {
        this.tenantActiveIndex = index;
        this.projectActiveIndex = -1;
      }
    },
    //选择项目
    choseProject(index) {
      this.projectActiveIndex = index;
      this.istenantProjectShow = false;
      this.changeTenant = true;
    },
    //搜索租户项目
    search() {
      if (!this.searchContent) {
        return;
      }
      let str = this.searchContent.toUpperCase();
      this.tenantProjectData = this.tenantProjectData.map(item => {
        item.show = false;
        if (
          item.tenant_name.toUpperCase().includes(str) ||
          item.desc.toUpperCase().includes(str)
        ) {
          item.show = true;
          if (item.projects.length > 0) {
            item.projects = item.projects.map(obj => {
              obj.show = true;
              return obj;
            });
          }
        } else if (item.projects.length > 0) {
          item.projects = item.projects.map(obj => {
            obj.show = false;
            obj.show =
              obj.project_name &&
              (obj.project_name.toUpperCase().includes(str) ||
                obj.name_zh.toUpperCase().includes(str))
                ? true
                : false;
            return obj;
          });
          item.show = item.projects.some(obj => {
            return obj.show;
          });
        }
        return item;
      });
      if (
        !this.tenantProjectData.some(obj => {
          return obj.show;
        })
      ) {
        this.searchNoData = true;
      } else {
        this.searchNoData = false;
      }
    },
    //处理搜索结果展示
    dealStr(str1, str2, str3, str4) {
      let heights = str => `<span style="color:#0080ff;">${str}</span>`;
      let reg = new RegExp(this.searchContent, "gi");
      return (
        str1.replace(reg, item => {
          return heights(item);
        }) +
        "-" +
        str3.replace(reg, item => {
          return heights(item);
        }) +
        " / " +
        str2.replace(reg, item => {
          return heights(item);
        }) +
        "-" +
        str4.replace(reg, item => {
          return heights(item);
        })
      );
    },
    //点击搜索结果
    searchClick(index, i) {
      this.tenantActiveIndex = index;
      this.choseProject(i);
    },
    // 确认切换项目
    ok() {
      let tenant = this.tenantProjectData[this.tenantActiveIndex];
      let project = tenant.projects[this.projectActiveIndex];
      let t = { name: tenant.tenant_name, id: tenant.tenant_id };
      let p = { name: project.project_name, id: project.project_id };
      localStorage.setItem("tenant", JSON.stringify(t));
      localStorage.setItem("project", JSON.stringify(p));
      cookies.setTenantProject(t, p); //所有租户项目在cookie里的操作都是为将租户项目带入其他域名
      window.location.reload();
    },
    /********************* */
    //登出
    loginout() {
      this.httpRequest({
        method: "POST",
        url: "/v1/logout"
      }).then(() => {
        localStorage.username = "";
        localStorage.userID = "";
        localStorage.useremail = "";
        this.$Notice.success({ title: this.i18nTitle("已登出!") });
        this.userName = "";
        this.useremail = "";
        localStorage.removeItem("tenant");
        localStorage.removeItem("project");
        cookies.deleteAuthorization();
        // cookies.delCookie('tenant_id')
        // cookies.delCookie('project_id')
        // cookies.delCookie('tenant_name')
        // cookies.delCookie('project_name')
        cookies.delTenantProject();
        this.messageCenter.wsStop = true;
        this.websock.close();
        this.$touch.initLogout();
        this.$publicMethod["login"]();
      });
    },
    //用户名下拉显示隐藏
    showUserMsg(res) {
      this.isShowUserMsg = res;
    },
    changeView(url) {
      this.$router.push({ name: url });
    },
    showMesCen(showFlag, top) {
      if (showFlag) {
        if (top) {
          this.messageCenter.messageFlag = true;
          this.$httpRequestEntrance.httpRequestEntrance(
            "GET",
            this.apiCenter.messages.site_messages.CRUD,
            { __orders: "is_read,-created_time" },
            resData => {
              this.messageCenter.messageList = resData.data;
            },
            { isNeedloading: false }
          );
        } else {
          this.messageCenter.messageFlag = true;
        }
      } else {
        this.messageCenter.messageFlag = false;
      }
    },
    gotoDetailPage(item, name) {
      this.messageCenter.messageFlag = false;
      let routerObj = {
        name: "siteMessagesDetail",
        params: {
          id: item.id
        }
      };
      if (name) {
        this.$Notice.close(name);
        let query = {
          type: "pop",
          messageId: item.channel_message_id
        };
        routerObj.query = query;
      }
      this.$router.push(routerObj);
      this.activeFirst = -1;
      this.activeFirstSpecial = 6;
      this.activeSecond = 0;
      this.isFeeMenuShow = false;
    },
    initWebSocket() {
      //初始化weosocket
      cookies.getAuthorization().then(res => {
        if (!res) {
          this.websockReconnect();
          return;
        }
        let token = res;
        let url = API.API.replace(/(http|https)/, "ws");
        const wsuri = url + "/ws_message?token=" + token;
        try {
          if ("WebSocket" in window) {
            this.websock = new WebSocket(wsuri);
          } else {
            this.$Notice({
              title: this.i18nTitle("兼容问题"),
              desc: this.i18nTitle(
                "您的浏览器不支持websocket协议,建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式！"
              )
            });
          }
          this.initEventHandle();
        } catch (e) {
          this.websockReconnect();
        }
      });
    },
    getUnread() {
      this.$httpRequestEntrance.httpRequestEntrance(
        "GET",
        this.apiCenter.messages.site_messages.CRUD + "/statistics",
        "",
        resData => {
          this.$store.commit("changeMessageNum", {
            init: true,
            init_num: resData.unread_num
          });
          this.initWebSocket();
        }
      );
    },
    initEventHandle() {
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      this.heartCheckReset();
      this.heartCheckStart();
    },
    websocketonerror() {
      //连接建立失败重连
      this.websockReconnect();
    },
    websocketonmessage(e) {
      //数据接收
      this.heartCheckReset();
      this.heartCheckStart();
      if (e.data == "ping") return;
      let receiveData = e.data;
      receiveData = JSON.parse(receiveData);
      if (receiveData.channel_message_id) {
        // 如果是返回消息内容，则表示要加
        this.$store.commit("changeMessageNum", {
          init: false,
          change_type: "add"
        });
        let name = uuidv1();
        if (receiveData.is_pop) {
          this.$Notice.warning({
            name: name,
            title: this.i18nTitle("消息通知"),
            duration: 0,
            render: h => {
              let a = [
                h(
                  "span",
                  {
                    style: {
                      fontSize: "16px",
                      cursor: "pointer"
                    },
                    on: {
                      click: () => {
                        this.gotoDetailPage(receiveData, name);
                      }
                    }
                  },
                  receiveData.subject
                )
              ];
              return h("div", a);
            }
          });
        }
      } else {
        // 这种情况是减，直接返回未读数
        let num = receiveData.unread_num;
        if (receiveData.unread_num > 99) num = 99;
        this.$store.commit("changeMessageNum", { init: true, init_num: num });
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose() {
      //关闭
      if (!this.messageCenter.wsStop) this.websockReconnect();
    },
    websockReconnect() {
      if (this.messageCenter.reconnectLock) return;
      this.messageCenter.reconnectLock = true;
      setTimeout(() => {
        this.initWebSocket();
        this.messageCenter.reconnectLock = false;
      }, 2000);
    },
    heartCheckReset() {
      clearTimeout(this.messageCenter.timeoutObj);
      clearTimeout(this.messageCenter.serverTimeoutObj);
    },
    heartCheckStart() {
      this.messageCenter.timeoutObj = setTimeout(() => {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        //onmessage拿到返回的心跳就说明连接正常
        this.websocketsend("ping");
        this.messageCenter.serverTimeoutObj = setTimeout(() => {
          //如果超过一定时间还没重置，说明后端主动断开了
          this.messageCenter.wsStop = true;
          this.websock.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
        }, this.messageCenter.timeout);
      }, this.messageCenter.timeout);
    },
    touchTrack(eventID = null, flag = null) {
      let params = {
        describe: null
      };
      if (flag === "tenantlist") {
        params.describe = "C_租户项目列表选择";
      } else if (flag === "tenantsearch") {
        params.describe = "C_租户项目列表搜索";
      }
      if (this.$validate.isEmpty(eventID)) {
        this.$touch.track(eventID, params);
      }
    }
  },
  beforeDestroy() {
    this.messageCenter.wsStop = true;
    if (this.websock.close) this.websock.close(); //离开路由之后断开websocket连接
  }
};
</script>
<style>
/*控制el级联选择显示顺序*/
.el-cascader-style {
  z-index: 3000 !important;
  width: 200px;
}
.el-cascader--small {
  width: 320px;
}
/*设置租户项目切换弹窗高度-开始*/
.ivu-select-dropdown {
  max-height: 250px;
}
.ivu-cascader-menu {
  height: 250px;
}
/*设置租户项目切换弹窗高度-结束*/
</style>
<style lang="less" scoped>
.menu {
  position: absolute;
  width: 100%;
  min-width: 1240px;
  height: 100%;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  .header {
    background-color: #000;
    height: 64px;
    line-height: 64px;
    display: flex;
    .logo {
      display: inline-block;
      margin-left: 10px;
      font-size: 16px;
      color: white;
      cursor: pointer;
      img {
        width: 140px;
      }
    }
    .change-tenant-prject {
      margin-left: 1px;
      padding: 0 16px;
      vertical-align: middle;
      display: inline-block;
      font-size: 14px;
      flex: 1;
      .tenantProject {
        position: absolute;
        color: #9e9e9e;
        background-color: #1e1e24;
        z-index: 2500;
        margin-top: -3px;
        margin-left: -25px;
        width: 1010px;
        transition: display 2s;
        .search {
          margin: 24px 0px 16px;
          div {
            width: 60%;
            background-color: #1e1e24;
            margin: auto;
            position: relative;
            input {
              -webkit-appearance: none; /*兼容safari否则样式不生效*/
              line-height: normal;
              width: 96%;
              border: 1px solid #6a6868;
              background-color: #1e1e24;
              height: 32px;
              color: #6a6868;
              padding: 5px 32px 5px 16px;
            }
            i {
              color: #6a6868;
              position: absolute;
              right: 38px;
              top: 25px;
            }
          }
        }
        .searchResult {
          max-height: 410px;
          overflow: auto;
          .searchResultItem {
            padding-left: 24px;
            line-height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .searchResultItem:hover {
            background-color: #000;
            cursor: pointer;
          }
        }
        .searchResult::-webkit-scrollbar {
          width: 6px;
        }
        .searchResult::-webkit-scrollbar-thumb {
          background-color: rgba(133, 132, 132, 0.226);
        }
        .searchResult::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #1e1e24;
        }
        .content {
          width: 100%;
          display: flex;
          flex: row nowrap;
          .dividingline {
            flex: none;
            border: 0.5px solid #303133;
            margin: 0px 4px;
          }
          .part {
            flex: none;
            padding-bottom: 10px;
            .title {
              line-height: 20px;
              padding: 0px 20px 5px;
              font-weight: bold;
            }
            .group {
              height: 410px;
              overflow-y: auto;
              .item {
                padding: 0px 20px;
                color: #9e9e9e;
                line-height: 40px;
                position: relative;
                width: 310px;
                height: 40px;
                span {
                  width: 254px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  display: inline-block;
                }
                i {
                  right: 8px;
                  position: absolute;
                  color: #1e1e24;
                  top: 14px;
                }
              }
              .itemActive {
                color: #0080ff;
                background-color: #16161a;
                i {
                  color: #0080ff;
                }
              }
              .item:hover {
                background-color: #16161a;
                color: #0080ff;
                cursor: pointer;
              }
              .forbid:hover {
                background-color: #16161a;
                color: #0080ff;
                i {
                  color: #1e1e24;
                }
              }
            }
            .group::-webkit-scrollbar {
              width: 6px;
            }
            .group::-webkit-scrollbar-thumb {
              background-color: rgba(133, 132, 132, 0.226);
            }
            .group::-webkit-scrollbar-track {
              border-radius: 10px;
              background-color: #1e1e24;
            }
          }
        }
      }
    }
    .tenant-project {
      display: inline-block;
      float: right;
      color: #fff;
      font-size: 14px;
      label {
        /*margin-right: 10px;*/
      }
      .label1 {
        margin-right: 30px;
      }
      .ava {
        display: inline-block;
        font-size: 14px;
        /*padding: 0px 20px;*/
        padding-right: 20px;
      }
      .avabc {
        // background-color: #0080FF
      }
      .feeCenter {
        display: inline-block;
        /*margin-right: 20px;*/
        .feeMenu {
          position: absolute;
          color: #fff;
          background-color: #000;
          z-index: 10;
          margin-top: -5px;
          margin-left: -80px;
          padding: 16px 0px;
          .feeMenuItem {
            padding: 8px 24px;
            line-height: 20px;
            font-size: 14px;
          }
          .feeMenuItem:hover {
            cursor: pointer;
            color: #0080ff;
          }
        }
      }
      .handleLog {
        color: #fff;
      }
      .handleLog:hover {
        color: #0080ff;
        cursor: pointer;
      }
      .language {
        display: inline-block;
        .langMenu {
          position: absolute;
          color: #fff;
          background-color: #000;
          z-index: 10;
          margin-top: -5px;
          margin-left: -50px;
          padding: 16px 0px;
          .langMenuItem {
            padding: 8px 24px;
            line-height: 20px;
            font-size: 14px;
          }
          .langMenuItem:hover {
            cursor: pointer;
            color: #0080ff;
          }
          .langActiveItem {
            color: #0080ff;
          }
        }
      }
      .littledivideline {
        display: inline-block;
        border: 0.5px solid #666;
        height: 18px;
        /*margin: 0px 25px 0px;*/
        margin: 0px 6px 0px;
        position: relative;
        top: 5px;
      }
    }
    .user-msg {
      display: block;
      position: absolute;
      background: #1e1e24;
      right: 24px;
      top: 64px;
      width: 200px;
      z-index: 99;
      margin-top: -3px;
      color: #c9c9c9;
      .user-info {
        font-size: 14px;
        line-height: 40px;
        padding-left: 24px;
        text-align: left;
        a {
          color: #c9c9c9;
        }
        a:hover {
          color: #1890ff;
          cursor: pointer;
        }
        span {
          // max-width: 100px;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
          display: inline-block;
          vertical-align: middle;
        }
        i {
          vertical-align: middle;
        }
      }
      .user-edit {
        margin-left: 15px;
        line-height: 32px;
        font-size: 14px;
      }
      .sign-out {
        border-top: 1px solid #666666;
        // padding-left: 24px;
      }
      .btn-sign-out {
        margin: 10px 0px;
        float: right;
        margin-right: 24px;
        a {
          border: 1px solid #b7b7b7;
          width: 63px;
          height: 28px;
          display: block;
          text-align: center;
          line-height: 26px;
          font-size: 14px;
          color: #c9c9c9;
          letter-spacing: 0;
          cursor: pointer;
          border-radius: 2px;
        }
        a:hover {
          background-color: #0080ff;
          border-color: #0080ff;
          color: #fff;
        }
      }
    }
    .firstMenu {
      display: inline-block;
      padding: 0px 20px;
      color: #fff;
      font-size: 14px;
      height: 60px;
      line-height: 60px;
    }
    .firstMenu:hover {
      border-bottom: 3px solid #0080ff;
    }
    .activeline {
      border-bottom: 3px solid #0080ff;
    }
  }
  .activedirection {
    transform: rotate(180deg);
  }
  .menucontainer {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    //  height: 100%;
    height: calc(100vh - 64px);
    position: relative;
    .menusub {
      position: absolute;
      width: 50px;
      height: inherit;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #1e1e24;
      font-size: 14px;
      color: #c9c9c9;
      flex: none;
      transition: all 0.2s ease-in-out;
      z-index: 1024;
      .trigger {
        text-align: center;
        height: 30px;
        padding: 3px 0;
      }
      .subbtn {
        padding: 10px 18px;
        width: 230px;
        cursor: pointer;
        img {
          // margin-right: 18px;
          margin-bottom: 2px;
        }
        i {
          float: right;
          line-height: 22px;
        }
      }
      .active {
        background-color: #121216;
        color: #fff;
      }
      .subbtn:hover {
        color: #0080ff;
        background-color: #1f1f20;
      }
      .rotate-icon {
        transform: rotate(-90deg);
      }
    }
    .menusub::-webkit-scrollbar-track {
      background: #333;
    }
    .menusub::-webkit-scrollbar-thumb {
      background: #121216;
    }
    // .menusub:hover{
    //     width: 230px;
    //     .rotate-icon{
    //       transform: rotate(0deg);
    //     }
    //     .subbtn{
    //       padding-left: 28px;
    //     }
    // }
    .submenu {
      display: flex;
      flex-flow: column;
      align-content: center;
      width: 180px;
      flex: none;
      background-color: #303133;
      height: 100%;
      margin-left: 50px;
      .subTitle {
        font-weight: bold;
        padding-left: 24px;
        height: 70px;
        line-height: 70px;
        color: #c9c9c9;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
      }
      .subTitleIcon {
        font-weight: bold;
        height: 70px;
        line-height: 70px;
        background: #d9dee4;
        font-size: 14px;
        color: #546478;
        text-align: center;
      }
      .subbtn {
        width: 100%;
        font-size: 14px;
        text-align: left;
        padding: 10px 0px 10px 24px;
        a {
          color: #c9c9c9;
        }
      }
      .subbtn:hover {
        a {
          color: #0080ff;
        }
      }
      .subactive {
        a {
          color: #0080ff;
        }
      }
      .subactive:hover {
        a {
          color: #0080ff;
        }
      }
    }
    .content {
      flex: 1;
      overflow-x: hidden;
      padding: 20px;
    }
    .cover {
      margin-left: -180px;
    }
    .navbar-collapse {
      position: absolute;
      left: 210px;
      top: 50%;
      width: 24px;
      height: 66px;
      -webkit-transition: all 0.1s ease, 0.1s ease;
      .navbar-collapse-content {
        top: -50%;
        position: relative;
        overflow: hidden;
        .navbar-collapse-bg {
          right: 0;
          left: auto;
          border-bottom: 12px solid transparent;
          border-left: none;
          border-right: 24px solid #f7f7f7;
          border-top: 12px solid transparent;
          width: 0;
          height: 66px;
          position: absolute;
          top: 0;
        }
        .navbar-collapse-inner {
          height: 66px;
          position: relative;
          text-align: center;
          cursor: pointer;
          left: auto;
          font-size: 15px;
          padding-top: 20px;
        }
      }
    }

    .left {
      margin-left: 50px;
    }
  }
  .navbar-collapse:hover {
    left: 206px;
    cursor: pointer;
  }
  .navbar-collapse-close {
    .submenu {
      display: none;
    }
    .content {
      margin-left: 50px;
    }
    .navbar-collapse {
      left: 46px;
      .navbar-collapse-content {
        .navbar-collapse-bg {
          border-right: none;
          border-left: 24px solid #eaedf1;
        }
      }
    }
    .navbar-collapse:hover {
      left: 50px;
    }
  }
}
.message-center {
  position: relative;
  cursor: pointer;
  i {
    position: relative;
    .message-badge {
      position: absolute;
      width: 20px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      border-radius: 50%;
      text-align: center;
      background-color: #ff6600;
      opacity: 0.9;
      top: -12px;
      right: -10px;
    }
  }
}
.message-list-box {
  z-index: 3;
  position: absolute;
  top: 64px;
  right: -4px;
  width: 250px;
  max-height: 300px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-bottom: none;
  box-shadow: #ddd 0 1px 6px 1px;
  ul {
    li {
      line-height: 48px;
      color: #505050;
      font-family: "PingFangSC-Regular";
      cursor: pointer;
      border-bottom: 1px solid #faf7fa;
      padding: 0 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      .preview {
        font-size: 12px;
        padding: 2px;
        background-color: #d9ecff;
        color: #0080ff;
        border-radius: 1px;
        margin-left: 6px;
      }
      .unread {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #0080ff;
      }
      .unread-hide {
        visibility: hidden;
      }
    }
    li:hover {
      background-color: #e9e9e9;
    }
    .viewMore {
      color: #989898;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue